import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.css'],
  standalone: false
})
export class CarouselComponent {
  items = [
    { name: 'Matriz RFM', image: './assets/images/item-1.png', url: 'https://www.youtube.com/watch?v=oay8Rp_cTK0&t=3s' },
    { name: 'Segmentações na prática', image: './assets/images/item-2.png', url: 'https://www.youtube.com/watch?v=ZQXU9utIqlo' },
    { name: 'Landing Pages', image: './assets/images/item-3.png', url: 'https://www.youtube.com/watch?v=E18_Zd-F7v4' },
    { name: 'Principais recursos Automation', image: './assets/images/item-4.png', url: 'https://www.youtube.com/watch?v=erISTL7IRtU' },
    { name: 'Nova feature', image: './assets/images/item-5.png', url: 'https://www.youtube.com/watch?v=K4GRbM7-DKo&pp=0gcJCcoJAYcqIYzv' },
    { name: 'Boas práticas', image: './assets/images/item-6.png', url: 'https://www.youtube.com/watch?v=p5uXByvjTRw' }
  ];

  responsiveOptions = [
    { breakpoint: '992px', numVisible: 2, numScroll: 1 },
    { breakpoint: '576px', numVisible: 1, numScroll: 1 }
  ];
}



